import React from 'react';
import { useIntl } from 'react-intl';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';

export const QuoteSchema = ({ intl }) => ({
  title: intl.formatMessage({ id: 'Quote', defaultMessage: 'Quote' }),
  fieldsets: [
    { id: 'default', title: 'Default', fields: ['text', 'author', 'role'] },
  ],
  properties: {
    text: {
      title: intl.formatMessage({
        id: 'Quote text',
        defaultMessage: 'Quote text',
      }),
      widget: 'textarea',
    },
    author: {
      title: intl.formatMessage({ id: 'Author', defaultMessage: 'Author' }),
    },
    role: {
      title: intl.formatMessage({ id: 'Role', defaultMessage: 'Role' }),
    },
  },
  required: ['text', 'author'],
});

export function QuoteView({ data, isEditMode = false }) {
  const intl = useIntl();
  if (!isEditMode && !data.text?.trim()) return null;
  return (
    <figure className="block bonn-quote">
      <blockquote className="bonn-quote-text">
        <p>
          {data.text ||
            intl.formatMessage({
              id: 'Quote text',
              defaultMessage: 'Quote text',
            })}
        </p>
      </blockquote>
      <figcaption className="bonn-quote-caption">
        <span className="bonn-quote-author">{data.author}</span>
        {data.role && <span className="bonn-quote-role">{data.role}</span>}
      </figcaption>
    </figure>
  );
}

export function QuoteEdit(props) {
  const {
    data,
    block,
    selected,
    onChangeBlock,
    blocksErrors,
    navRoot,
    contentType,
  } = props;
  const intl = useIntl();
  const schema = QuoteSchema({ intl });
  return (
    <>
      <QuoteView data={data} isEditMode />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          formData={data}
          block={block}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          onChangeBlock={onChangeBlock}
          errors={blocksErrors}
          navRoot={navRoot}
          contentType={contentType}
        />
      </SidebarPortal>
    </>
  );
}
